import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ContentLayout from "../../components/ContentLayout/ContentLayout";
import { AdminStatsCard } from "../../components/DashboardActionCards/AdminStatsCard";
import HomeTablesContainer from "../../components/Home/HomeTablesContainer";
import { getSavedState } from "../../services/localStorage";
import ReportTablesContainer from "../../components/Home/ReportTablesContainer";
import { getReportSummary } from "../../services/selfService";
import ReportIcon from '../../assets/img/reportIcon.svg'

const SelfServiceAdminReport = () => {
   
  const [reportSummary, setReportSummary] = useState<any>(null);
  //   const isMobile = useIsMobile();
  const isMobile = false;
  const navigate = useNavigate();

  const fetchWalletBalance = async () => {
    try {
      const reportResponse = await getReportSummary();

      if (reportResponse.data && reportResponse.data.isSuccessful) {
        setReportSummary(reportResponse.data.data);
      }
    } catch (error) {}
    // setWalletBalance(response.data.balance);
  };

  useEffect(() => {
    fetchWalletBalance();
  }, []);

  const adminStats = useMemo(() => {
    return [
      { label: "Total power purchased", value: reportSummary?.totalUnitsVended || 0 },
      { label: "Total transactions", value: reportSummary?.totalTransactions || 0 },
      { label: "Pending transactions", value: reportSummary?.totalPendingTransactions || 0 },
    ];
  }, [reportSummary]);

  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const handleSettings = () => {
    if (isMobile) {
      setShowSettingsModal(false);
      navigate("/settings");
      return;
    } else {
      setShowSettingsModal(true);
    }
  };
  return (
    <ContentLayout headerName="Report" iconName={ReportIcon}>
      <div className="w-full px-6  py-4  flex flex-col gap-4 !overflow-hidden ">
        <div className="flex flex-col gap-12">
          <div className="w-full   mx-auto ">
            <AdminStatsCard stats={adminStats} />
          </div>
          <ReportTablesContainer />
        </div>

        {/* <ModalContainer
          showTopCancelButton={false}
          showModal={showSettingsModal}
          setShowModal={setShowSettingsModal}
          width={800}
        >
          <Settings />
        </ModalContainer> */}
      </div>
    </ContentLayout>
  );
};

export default SelfServiceAdminReport;
